import { donorConnectTabs } from './tabs';

export const tabMap = [
    { id: 1, name: donorConnectTabs.UNASSIGNED, url: '/donor-connect/unassigned' },
    { id: 2, name: donorConnectTabs.TODO, url: '/donor-connect/to-do' },
    { id: 3, name: donorConnectTabs.MINE, url: '/donor-connect/assigned-to-me' },
    { id: 4, name: donorConnectTabs.ALL, url: '/donor-connect/all' }
];